import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox/';
import { Input } from 'ui-components/components/input';
import { noop } from 'ui-components/default-props/noop';
import { smsNotification } from '../../../../services/other-shipping-options/constants';
import { FormattedMessagePropType } from '../../../../prop-types/intl';
import { BULK_UPDATE_FULFILLMENT_PLAN_ID } from '../../constants';

import messages from './messages';
import style from './inputs.module.less';
import { emptyObject } from 'ui-components/default-props/empty';

const updatePhone = (data, value, updateOption) => {
  const newValue = {
    ...data,
    phone: value,
  };
  updateOption({ id: smsNotification, value: newValue });
};

const renderSMSInput = (data, updateOption, updateInput) => {
  const { phone } = data;
  return (
    <div className={style['single-input']}>
      <Input
        label={<FormattedMessage {...messages.phoneLabel} />}
        onBlur={(v) => updateOption(v)}
        onChange={(v) => updateInput(v)}
        value={phone}
      />
    </div>
  );
};

export const SMSNotificationOption = ({
  label,
  checked = false,
  fulfillmentPlanId,
  onCheck = noop,
  optionData = emptyObject,
  updateOption = noop,
  updateInput = noop,
}) => {
  const isBulkUpdate = fulfillmentPlanId === BULK_UPDATE_FULFILLMENT_PLAN_ID;

  const handleOnChange = useCallback(
    (isChecked) => {
      let newValue;
      if (isChecked) {
        newValue = {
          useOrderSms: true,
        };
      }
      updateOption({
        id: smsNotification,
        value: newValue,
        checked: isChecked,
      });
    },
    [updateOption],
  );

  if (isBulkUpdate) {
    return (
      <div>
        <Checkbox checked={checked} label={label} onChange={handleOnChange} />
        <div className={style['notification-option-sublabel']}>
          <FormattedMessage {...messages.phoneSublabel} />
        </div>
      </div>
    );
  }

  return (
    <div>
      <Checkbox checked={checked} label={label} onChange={onCheck} />
      {checked &&
        renderSMSInput(
          optionData,
          (phoneNumber) => updatePhone(optionData, phoneNumber, updateOption),
          (phoneNumber) => updatePhone(optionData, phoneNumber, updateInput),
        )}
    </div>
  );
};

SMSNotificationOption.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  label: FormattedMessagePropType.isRequired,
  checked: PropTypes.bool,
  onCheck: PropTypes.func,
  optionData: PropTypes.object,
  updateOption: PropTypes.func,
  updateInput: PropTypes.func,
};
